import {z} from 'zod'

import {businessDateOnlyFromIso, businessTimestampFromIso} from './business-time'

export const tzDateFromIso = z.string().transform(businessTimestampFromIso)
export const dateOnlyFromIso = z.string().transform(businessDateOnlyFromIso)
